// src/Redux/slices/allSites.ts
import { createSlice } from '@reduxjs/toolkit';

interface GlobalState {
  sites: any[];
}

const initialState: GlobalState = {
  sites: [],
};

export const allSitesSlice = createSlice({
  name: 'associatedSites',
  initialState,
  reducers: {
    setSites: (state, action) => {
      state.sites = action.payload;
    },
    addSite: (state, action) => {
      state.sites.push(action.payload);
    },
    removeSite: (state, action) => {
      state.sites = state.sites.filter((site) => site._id !== action.payload);
    },
    // NEW: Updates a specific site in the list after editing
    updateSiteInList: (state, action) => {
      const index = state.sites.findIndex(
        (site) => site._id === action.payload._id
      );
      if (index !== -1) {
        state.sites[index] = action.payload;
      }
    },
  },
});

export const { addSite, setSites, removeSite, updateSiteInList } =
  allSitesSlice.actions;

export default allSitesSlice.reducer;
